import {
    MobileInProgressImageContainerStyled,
    MobileInProgressImageContentStyled,
    MobileInProgressWrapperStyled
} from "./styled/MobileInProgressStyled";
import WelcomeHeader from "../Welcome/WelcomeHeader";
import { useSetBodyBackgroundColor } from "../../components/UseSetBodyBackgroundColor/useSetBodyBackgroundHooks";
import { isClientMobile } from "../../components/ClientInfo/ClientInfo";
import { useLangContext } from "../../providers/LangProvider/LangProviderContext.js";

export const MobileInProgress = () => {
    const {getLangPath} = useLangContext();
    useSetBodyBackgroundColor('var(--color-surface-secondary)', true);
    return (
            <MobileInProgressWrapperStyled>
                <WelcomeHeader/>
                <MobileInProgressImageContentStyled>
                    <MobileInProgressImageContainerStyled>
                        <img src="/assets/app-links/macbook-pro.png"/>
                    </MobileInProgressImageContainerStyled>
                    {isClientMobile && <h1 style={{marginTop: '10px', marginBottom: '24px'}}>
                        {getLangPath('coming_soon.title')}
                    </h1>}
                    <p style={isClientMobile ? {} : {marginTop: '50px'}}>{getLangPath('coming_soon.text')}</p>
                    <p>{getLangPath('coming_soon.trade_on_desktop')}</p>
                    <h5>fx.binomo.com</h5>
                </MobileInProgressImageContentStyled>
            </MobileInProgressWrapperStyled>
    );
};